import { ArrowRight } from 'lucide-react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MentionsInbox } from '@/components/ui';
import { DEFAULT_INBOX_FILTER, type InboxSort } from '@/lib/mentionsInbox';
import { HOME, ENTITIES } from '../conversations/model';
import { makeInboxEntries, AGE_OPTIONS } from '../conversations/inboxModel';
import { ResponseTimeDemo } from '../conversations/InboxDemo';
import { Code } from './Section';

export function InboxPatternTiles() {
  const [entries] = useState(() => makeInboxEntries(Date.now()).slice(0, 4));
  const [filter, setFilter] = useState(DEFAULT_INBOX_FILTER);
  const [sort, setSort] = useState<InboxSort>('recent');
  const [density, setDensity] = useState<'comfortable' | 'compact'>('comfortable');
  const navigate = useNavigate();
  return (
    <>
      <div data-slot="inbox-pattern-tile" className="overflow-hidden rounded-lg border border-line bg-card">
        <div className="flex flex-wrap items-center gap-4 border-b border-line p-5">
          <div className="min-w-0 flex-1">
            <h3 className="type-heading">Единый ящик</h3>
            <p className="mt-1 text-sm text-fg-muted">
              Упоминания и обращения из разных каналов, сгруппированные по веткам.
            </p>
          </div>
          <Link
            to={HOME + '?demo=inbox'}
            className="inline-flex h-9 items-center gap-2 rounded-md border border-line bg-muted px-3 text-xs font-semibold text-fg hover:bg-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
          >
            Открыть ящик
            <ArrowRight className="size-4" />
          </Link>
        </div>
        <div className="max-h-96 overflow-y-auto p-5">
          <MentionsInbox
            entries={entries}
            filter={filter}
            onFilterChange={setFilter}
            sort={sort}
            onSortChange={setSort}
            ageOptions={AGE_OPTIONS}
            density={density}
            onDensityChange={setDensity}
            entities={ENTITIES}
            onEntityOpen={(entity) => navigate(HOME + '/entity/' + entity.id)}
            onOpenSource={(thread) => navigate(HOME + '/source/' + thread.entries[0].id)}
            onReply={() => navigate(HOME + '?demo=inbox')}
          />
        </div>
        <p className="border-t border-line p-4">
          <Code>MentionsInbox · InboxRowSkeleton · InboxEntry · InboxThread</Code>
        </p>
      </div>
      <div
        data-slot="response-pattern-tile"
        className="overflow-hidden rounded-lg border border-line bg-card"
      >
        <div className="p-5">
          <ResponseTimeDemo />
        </div>
        <p className="border-t border-line p-4">
          <Code>ResponseTimer · ResponseWait · LiveValue variant="elapsed"</Code>
        </p>
      </div>
    </>
  );
}
